<div class="policy-shell container">
	<article class="entry">
		<header class="policy-header">
			<nav class="policy-nav">
				<a class="textlink" [href]="'/'" role="menuitem">
					portfolio
				</a>
				<a class="textlink" [href]="'/blog'" role="menuitem" >
					blog
				</a>
				<div class="nav-right">
					<app-logo-context-menu></app-logo-context-menu>
				</div>
			</nav>
			<h1>Terms of Use</h1>
			<p class="last-updated">Last Updated: July 13, 2026</p>
		</header>
		<div class="policy-content entry-content">
			<section>
				<h2>1. Acceptance of Terms</h2>
				<p>
					These Terms of Use ("Terms") constitute a legal agreement between you and our company ("Company," "we,"
					"us," "our"). By accessing and using our website, mobile applications, and related services
					(collectively, the "Services"), you acknowledge that you have read, understood, and agree to be bound
					by these Terms. If you do not agree to these Terms, please do not use the Services.
				</p>
			</section>
			<section>
				<h2>2. Eligibility</h2>
				<p>
					By using the Services, you represent and warrant that:
				</p>
				<ul>
					<li>You are at least 18 years old (or the age of legal majority in your jurisdiction)</li>
					<li>You have the right and authority to enter into this agreement</li>
					<li>You are not prohibited from using the Services under any applicable law</li>
					<li>You will comply with all applicable laws and regulations</li>
				</ul>
				<p>
					Parents or guardians may permit minors under their care to use the Services, subject to their
					supervision and responsibility for compliance with these Terms.
				</p>
			</section>
			<section>
				<h2>3. User Accounts</h2>
				<h3>3.1 Account Creation</h3>
				<p>
					To access certain features of the Services, you may need to create an account. You agree to provide
					accurate, current, and complete information and to maintain the accuracy of such information.
				</p>
				<h3>3.2 Account Security</h3>
				<p>
					You are responsible for maintaining the confidentiality of your account credentials and for all activities
					that occur under your account. You agree to notify us immediately of any unauthorized use of your account
					or any other security breach.
				</p>
				<h3>3.3 Account Termination</h3>
				<p>
					We reserve the right to terminate or suspend your account at any time, with or without cause, and without
					prior notice or liability to you.
				</p>
			</section>
			<section>
				<h2>4. Acceptable Use Policy</h2>
				<p>
					You agree not to use the Services in any manner that:
				</p>
				<ul>
					<li>Violates any applicable law, regulation, or third-party rights</li>
					<li>Infringes on intellectual property rights, including copyrights, trademarks, or patents</li>
					<li>Is threatening, abusive, defamatory, obscene, or otherwise offensive</li>
					<li>Harasses, intimidates, or bullies other users</li>
					<li>Transmits viruses, malware, or any code of a destructive nature</li>
					<li>Attempts to gain unauthorized access to our systems or networks</li>
					<li>Impersonates or misrepresents your identity or affiliation</li>
					<li>Engages in spam, phishing, or other deceptive practices</li>
					<li>Scrapes, crawls, or automated downloads without permission</li>
					<li>Reverse engineers, decompiles, or attempts to discover the source code or underlying technology</li>
				</ul>
			</section>
			<section>
				<h2>5. Intellectual Property Rights</h2>
				<h3>5.1 Our Content</h3>
				<p>
					The Services, including all content, features, and functionality (such as text, graphics, images, software,
					and design), are owned by the Company, its licensors, or other providers of such material and are protected
					by United States and international copyright, trademark, and other intellectual property laws.
				</p>
				<h3>5.2 Limited License</h3>
				<p>
					We grant you a limited, non-exclusive, non-transferable license to access and use the Services for your
					personal, non-commercial purposes. This license does not include the right to:
				</p>
				<ul>
					<li>Modify, copy, or distribute the Services</li>
					<li>Use the Services for commercial purposes</li>
					<li>Remove any copyright, trademark, or other proprietary notices</li>
					<li>Reverse engineer or attempt to discover underlying code</li>
				</ul>
				<h3>5.3 User-Generated Content</h3>
				<p>
					You retain ownership of any content you create and upload to the Services ("User Content"). However, by
					uploading User Content, you grant the Company a worldwide, royalty-free, non-exclusive, perpetual, and
					irrevocable license to use, reproduce, modify, distribute, and display your User Content in connection
					with the Services and our business operations.
				</p>
			</section>
			<section>
				<h2>6. Disclaimer of Warranties</h2>
				<p>
					THE SERVICES ARE PROVIDED ON AN "AS-IS" AND "AS-AVAILABLE" BASIS WITHOUT ANY WARRANTIES, EXPRESS OR IMPLIED.
					TO THE FULLEST EXTENT PERMITTED BY LAW, THE COMPANY DISCLAIMS ALL WARRANTIES, INCLUDING IMPLIED WARRANTIES
					OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
				</p>
				<p>
					We make no warranty that:
				</p>
				<ul>
					<li>The Services will meet your requirements</li>
					<li>The Services will be uninterrupted, timely, secure, or error-free</li>
					<li>Any defects in the Services will be corrected</li>
					<li>The Services or servers are free of viruses or other harmful components</li>
				</ul>
			</section>
			<section>
				<h2>7. Limitation of Liability</h2>
				<p>
					TO THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT SHALL THE COMPANY, ITS AFFILIATES, OFFICERS,
					DIRECTORS, EMPLOYEES, AGENTS, OR LICENSORS BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL,
					PUNITIVE, OR EXEMPLARY DAMAGES, INCLUDING BUT NOT LIMITED TO DAMAGES FOR LOSS OF PROFITS, GOODWILL, USE,
					DATA, OR OTHER INTANGIBLE LOSSES, EVEN IF THE COMPANY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
				</p>
				<p>
					OUR TOTAL LIABILITY TO YOU FOR ALL CLAIMS ARISING FROM OR RELATING TO THESE TERMS OR THE SERVICES SHALL NOT
					EXCEED THE FEES YOU HAVE PAID TO US IN THE TWELVE (12) MONTHS PRECEDING THE CLAIM, OR $100, WHICHEVER IS
					GREATER.
				</p>
			</section>
			<section>
				<h2>8. Indemnification</h2>
				<p>
					You agree to indemnify, defend, and hold harmless the Company and its affiliates, officers, directors,
					employees, and agents from any claims, demands, losses, liabilities, and expenses (including reasonable
					attorneys' fees) arising from or relating to:
				</p>
				<ul>
					<li>Your use of the Services</li>
					<li>Your violation of these Terms</li>
					<li>Your User Content</li>
					<li>Your violation of any applicable law or third-party rights</li>
				</ul>
			</section>
			<section>
				<h2>9. Third-Party Links and Services</h2>
				<p>
					The Services may contain links to third-party websites and services. We are not responsible for the content,
					accuracy, or practices of third-party services. Your interaction with third-party services is governed by
					their terms of service and privacy policies. We encourage you to review such terms before using any
					third-party service.
				</p>
			</section>
			<section>
				<h2>10. Modifications to the Services</h2>
				<p>
					We reserve the right to modify, suspend, or discontinue the Services at any time, with or without notice.
					We shall not be liable to you or any third party for any modification, suspension, or discontinuation of
					the Services.
				</p>
			</section>
			<section>
				<h2>11. Modifications to These Terms</h2>
				<p>
					We reserve the right to modify these Terms at any time. We will notify you of any material changes by
					posting the updated Terms on our website and updating the "Last Updated" date. Your continued use of the
					Services following such notification constitutes your acceptance of the modified Terms.
				</p>
			</section>
			<section>
				<h2>12. Governing Law and Jurisdiction</h2>
				<p>
					These Terms shall be governed by and construed in accordance with the laws of [Your Jurisdiction], without
					regard to its conflict of law provisions. You agree to submit to the exclusive jurisdiction of the courts
					located in [Your Jurisdiction] for any disputes arising from these Terms or the Services.
				</p>
			</section>
			<section>
				<h2>13. Dispute Resolution</h2>
				<p>
					Before initiating legal proceedings, you agree to attempt to resolve any dispute by sending us a written
					notice describing the nature of the dispute, your proposed solution, and your signature. If the dispute is
					not resolved within thirty (30) days, either party may pursue legal remedies.
				</p>
			</section>
			<section>
				<h2>14. Severability</h2>
				<p>
					If any provision of these Terms is found to be invalid or unenforceable, such provision shall be modified
					to the minimum extent necessary to make it enforceable, or if such modification is not possible, the provision
					shall be severed. The remaining provisions shall remain in full force and effect.
				</p>
			</section>
			<section>
				<h2>15. Entire Agreement</h2>
				<p>
					These Terms, together with our Privacy Policy and any other policies posted on our website, constitute the
					entire agreement between you and the Company and supersede all prior and contemporaneous agreements,
					understandings, and negotiations, whether written or oral.
				</p>
			</section>
			<section>
				<h2>16. Contact Us</h2>
				<p>
					If you have questions about these Terms of Use, please contact us at:
				</p>
				<div class="contact-info">
					<p>Email: create&commat;nhdsgn.com</p>
				</div>
			</section>
		</div>
	</article>
</div>
<nh-footer></nh-footer>